import { render, staticRenderFns } from "./PersionalProtection.vue?vue&type=template&id=68b19ea5&"
import script from "./PersionalProtection.vue?vue&type=script&lang=js&"
export * from "./PersionalProtection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports